import {
  type AmountV1CurrencyEnum,
  type OfferPriceV1,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { PRODUCT_TEMPLATES } from '../productTemplates'

export const productAccessorIsFreeShipping = ({
  currentPrescriptionType,
  displayPrice,
  freeShippingThreshold,
  productTemplate,
}: {
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  displayPrice: OfferPriceV1 | null
  freeShippingThreshold: {
    amount: number | null | undefined
    currency: AmountV1CurrencyEnum
  }
  productTemplate: PRODUCT_TEMPLATES
}): boolean => {
  const shouldBeFreeShipping =
    displayPrice?.price !== undefined &&
    displayPrice.price !== 0 &&
    typeof freeShippingThreshold.amount === 'number' &&
    displayPrice.price >= freeShippingThreshold.amount

  switch (productTemplate) {
    case PRODUCT_TEMPLATES.OTX: {
      return (
        currentPrescriptionType !==
          PrescriptionPrescriptionTypeEnum.NoPrescription ||
        shouldBeFreeShipping
      )
    }
    case PRODUCT_TEMPLATES.RX: {
      return true
    }
    default: {
      return shouldBeFreeShipping
    }
  }
}
